import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import ListagemHeader from '../../../components/gww-lib/listagens-header';
import NavBar from '../../../components/layout/navbar/index';

function ListaPessoa({ history }) {

    function vaiPessoa(registroUnico) {
        history.push('/cadastro-pessoa', { registroUnico });
    }

    const columns = {
        dic: [
            { id: 'CCDPESS', label: 'Código', minWidth: 10 },
            { id: 'CDSPESS', label: 'Descrição', minWidth: 10 },
            {
                id: 'CFONE',
                label: 'Telefone',
                minWidth: 10,
                align: 'right',
                format: value => value.toLocaleString(),
            },
            {
                id: 'CDSCIDADE',
                label: 'Cidade',
                minWidth: 170,
                align: 'right',
                format: value => value.toFixed(2),
            },
        ]
    };

    let filtrosPessoa = {
        dic: [
            {
                campoFiltro: "CDSPESS",
                descricaoFiltro: "Nome",
            },
            {
                campoFiltro: "CNPJ",
                descricaoFiltro: "CNPJ",
                removeMascara: true,
            },
            {
                campoFiltro: "CCPF",
                descricaoFiltro: "CPF",
                removeMascara: true,
            }
        ],
    };

    return (
        <Fragment>
            <NavBar />
            <ListagemHeader
                filtros={filtrosPessoa}
                columns={columns}
                tela="ListaPessoa"
                titulo="Pessoa"
                nomeChave="PCCDPESS"
                metodoListagem="WEBSITE_LIST_GPESSOA_L"
                metodoConsultaUnica="WEBSITE_GPESSOA_L_BYID"
                vaiPara={(registro) => vaiPessoa(registro)}
            />
        </Fragment>
    )
}

export default withRouter(ListaPessoa);